<style lang="scss">
.loader-comp {
  @include centerContent();
  z-index: 9999;
  background-color: rgba(255,255,255,0.4);
  pointer-events: none;

  .loader {
    border: 10px solid #f3f3f3; /* Light grey */
    border-top: 10px solid $mauve; /* Blue */
    border-radius: 50%;
    width: 90px;
    height: 90px;
    animation: spin 1.3s linear infinite;
    position: absolute;
    top: 25%;
    left: 50%;
    transform: translate(-50%,-50%);
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
}
</style>

<!-- eslint-disable -->
<template>
  <div class="loader-comp full-width min-height">
    <div class="loader"></div>
  </div>
</template>
<!-- eslint-enable -->

<script>
  export default {
    components: {},
    props: {},
    data() {
      return {
        test: '',
      };
    },
    mounted() {

    },
    methods: {

    },
  };
</script>
